<template>
  <div class="team-user">
    <div class="m-container">
      <div class="head-title">
        <p>Team Info</p>
      </div>
      <div class="row">
        <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
        <loading v-if="loading_page"></loading>
        <!-- start form part -->
        <div class="the-form" v-else>
          <div class="form-body">
            <!-- form -->
            <q-form @submit.preven="updateTeamInfo">
              <div class="row q-col-gutter-sm">
                <div class="col-xs-12">
                  <label>City</label>
                  <q-input bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.city" :rules="formRules.city"/>
                </div>
                <div class="col-xs-12">
                  <label>School name</label>
                  <q-input bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.school" :rules="formRules.school"/>
                </div>
                <div class="col-xs-12">
                  <label>Coach code</label>
                  <q-input bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.coach_code" :rules="formRules.coach_code"/>
                </div>
                <div class="col-xs-12">
                  <label>Sub Admin</label>
                  <q-select
                      filled
                      :options="subAdminOptions"
                      v-model="formData.subadmin"
                      map-options
                      emit-value
                      :rules="formRules.subadmin"
                  ></q-select>
                </div>
                <div class="col-xs-12 col-sm-6">
                  <label>Team social account one</label>
                  <q-input bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.social1" :rules="formRules.social1"/>
                </div>
                <div class="col-xs-12 col-sm-6">
                  <label>Team social account two</label>
                  <q-input bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.social2" :rules="formRules.social2"/>
                </div>
                <div class="col-xs-12">
                  <label>Team Gender</label>
                  <q-select
                      filled
                      :options="genderOptions"
                      v-model="formData.team_gender"
                      option-label="label" option-value="value"
                      map-options
                      emit-value
                      :rules="formRules.team_gender"
                  ></q-select>
                </div>
                <div class="col-xs-12">
                  <label>About</label>
                  <q-input type="textarea" bg-color="positive" reactive-rules label-color="secondary" filled
                           v-model="formData.about" :rules="formRules.about"/>
                </div>
              </div>
              <div class="submit">
                <div class="the-button">
                  <button class="wro-button secondaryButtons">
                    <q-spinner
                        color="purple-1"
                        size="2em"
                        :thickness="2"
                        v-if="spinner_loading"
                    />
                    <span v-else>Save Changes</span></button>
                  <span class="skew-line-w"></span>
                </div>
                <!-- end send message  button -->
              </div>
              <p class="error" v-for="err in error">{{err}}</p>

            </q-form>

            <!-- end form -->
          </div>
        </div>
        <!-- end form part -->
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent";
import { Notify } from 'quasar'
import Loading from "../../components/Loading/loading";
export default {
  data() {
    return {
      alert: false,
      spinner_loading: false,
      loading_page: false,
      teamInfo: null,
      cityOptions: [
        {
          value: 'male',
          label: 'Male'
        },
        {
          value: 'female',
          label: 'Female'
        }],
      genderOptions: [
        {
          value: 'male',
          label: 'Male'
        },
        {
          value: 'female',
          label: 'Female'
        }],
      subAdminOptions: [],
      formData: {
        school: null,
        social1: null,
        social2: null,
        subadmin: null,
        about: null,
        city: null,
        coach_code: null,
        team_gender: null,
      },
      loading: false,
      error: null,
      formRules: {
        school: [val => val !== null && val !== '' || 'Please enter your school'],
        social1: [val => val !== null && val !== '' || 'Please enter your social1'],
        social2: [val => val !== null && val !== '' || 'Please enter your social2'],
        subadmin: [val => val !== null && val !== '' || 'Please enter your subadmin'],
        about: [val => val !== null && val !== '' || 'Please enter your about'],
        city: [val => val !== null && val !== '' || 'Please enter your city'],
        coach_code: [val => val !== null && val !== '' || 'Please enter your coach code'],
        team_gender: [val => val !== null && val !== '' || 'Please enter your team gender'],
      },
    }
  },
  components: {Loading, ButtonComponent},
  methods: {
    updateTeamInfo() {
      this.spinner_loading = true;
      this.$API.teams.update_all_teamInfo(this.teamInfo.id,this.formData)
      .then(res => {
        this.spinner_loading = false;
        Notify.create({
          message: 'Changes Success!',
          color: 'green',
          position: 'top'
        })

      }).catch(error => {
        this.spinner_loading = false;
        this.error = error;
        this.alert = true;
      });
    }
  },
  mounted() {
    this.loading_page = true;

    this.$API.teams.get_my_team()
    .then(res => {
      this.teamInfo = res.data[0];
      let keys = Object.keys(this.formData);
      keys.forEach(el => {
        this.formData[el] = this.teamInfo[el];
      });

      /** get sub admin **/
      this.$API.general.getSubAdmin()
      .then(res => {
        res.map(el => {
          this.subAdminOptions.push({
            value: el.id.toString(),
            label: el.name
          })
        })
        this.loading_page = false;
      }).catch(() => {})

    }).catch( error => {
    });
  }
}
</script>


<style scoped>
.q-form {
  max-width: 800px;
  margin: auto;
}

.team-user {
  padding: 40px 0;
}

.the-form {
  width: 100%;
}

.the-form .form-body form {
  padding: 0px;
}

.the-form .form-body form .upload-image {
  padding-left: 20px;
  position: relative!important;
}

.img-perview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  border-right: 5px;
  padding: 5px;
}

.the-form .form-body form .upload-image svg {
  position: absolute;
  bottom: 25px;
  right: 25px;
  font-size: 50px;
  color: #cccc;
}

.the-form .form-body form .upload-image .upload-holder {
  background: #F4F5F8;
  height: 231px;
}

@media screen and (max-width: 600px) {
  .upload-image {
    padding-left: 0 !important;
  }
}

.submit {
  margin-top: 25px;
}
</style>
